exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".monaco-quickfix{margin-left:0;font-size:.8rem;transition:opacity .2s;opacity:.6;cursor:pointer}.monaco-quickfix:hover{opacity:1!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/app/monaco/addons/quickFix.css
 ** module id = 194
 ** module chunks = 0
 **/